export default __webpack_public_path__ + "static/media/Icons_Down Arrow Icon.8e142b2f.svg";